import React from "react";

const ABOUT_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_voice-demos-1/artifacts/pzlcusfh_2_foto_sobre_mi.png";

export default function About() {
  return (
    <section
      id="sobre-mi"
      className="relative py-24 md:py-32 px-6 md:px-12"
      data-testid="about-section"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        {/* Bio text */}
        <div className="md:col-span-7 order-2 md:order-1">
          <div className="text-xs tracking-[0.3em] uppercase text-[#F25C32] mb-6">
            — Sobre mí
          </div>
          <h2 className="heading-display text-4xl sm:text-5xl md:text-6xl text-[#F5F5F0] mb-10 leading-[0.95]">
            Santiago<br />
            <span className="text-[#F25C32]">Ramírez C.</span>
          </h2>

          <div className="space-y-6 text-[#F5F5F0]/85 text-base sm:text-lg leading-relaxed max-w-2xl">
            <p>
              Soy <strong className="text-[#F5F5F0]">actor, director, locutor y artista vocal chileno</strong>, con una trayectoria
              que integra el trabajo escénico, la comunicación y la interpretación de la palabra.
            </p>
            <p>
              Mi experiencia abarca <em className="not-italic text-[#F25C32]">teatro, televisión, doblaje, publicidad, audiolibros,
              documentales, contenidos corporativos y proyectos de radio</em>, desarrollando una voz versátil capaz
              de adaptarse a distintos registros — desde la interpretación dramática hasta la comunicación
              institucional.
            </p>
            <p>
              Como actor de voz, destaco por construir relatos con <strong className="text-[#F5F5F0]">profundidad emocional</strong>,
              precisión interpretativa y una cuidada musicalidad del lenguaje. Mi trabajo combina técnica vocal,
              manejo de la prosodia y una especial atención al ritmo narrativo.
            </p>
            <p>
              Soy la voz de <strong className="text-[#F5F5F0]">Radio Duna 89.7 FM</strong> en Santiago de Chile desde 1995, y hace 9 años
              tengo mi programa musical llamado <strong className="text-[#F5F5F0]">Duna Jazz</strong>.
            </p>
            <p className="text-[#9CA3AF] italic">
              "La voz es mucho más que un medio de comunicación: cada interpretación es una oportunidad para
              emocionar, inspirar y crear una experiencia significativa para quien escucha."
            </p>
          </div>

          {/* Disciplines pills */}
          <div className="mt-10 flex flex-wrap gap-3" data-testid="disciplines-list">
            {[
              "Actuación",
              "Locución",
              "Doblajes",
              "Producción audiovisual",
              "Escritura de guiones",
              "Docencia",
              "Cultura organizacional",
            ].map((d) => (
              <span
                key={d}
                className="px-4 py-2 text-xs tracking-[0.15em] uppercase border border-white/15 rounded-full text-[#F5F5F0]/75 hover:border-[#F25C32] hover:text-[#F25C32] transition-colors"
              >
                {d}
              </span>
            ))}
          </div>
        </div>

        {/* Portrait */}
        <div className="md:col-span-5 order-1 md:order-2 md:sticky md:top-32">
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
            <img
              src={ABOUT_PORTRAIT}
              alt="Santiago Ramírez retrato"
              className="grayscale-image w-full h-full object-cover"
              data-testid="about-portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0a1024]/50" />
          </div>
          <a
            href="#demos"
            className="mt-6 inline-flex items-center gap-4 text-xs tracking-[0.25em] uppercase text-[#F5F5F0]/80 hover:text-[#F25C32] transition-colors"
            data-testid="about-cta-demos"
          >
            <span className="w-12 h-12 rounded-full bg-[#F25C32] flex items-center justify-center pulse-ring">
              <i className="fa-solid fa-play text-white text-sm ml-0.5" />
            </span>
            Escucha mis demos
          </a>
        </div>
      </div>
    </section>
  );
}
